import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BrandsFeatureKey, BrandState } from './brands.reducer';

// Create a feature selector to access the brand state
export const selectBrandState = createFeatureSelector<BrandState>(BrandsFeatureKey);

// Selectors to get pieces of state
export const selectAllBrands = createSelector(selectBrandState, (state) => state.brands);
export const selectBrandById = (brandId: number) => createSelector(selectAllBrands, (brands) => brands.find(brand => brand.BrandId === brandId));
export const selectBrandsLoaded = createSelector(selectBrandState, (state) => state.loaded);
export const selectBrandsError = createSelector(selectBrandState, (state) => state.error);
